(() => {
    Metro.i18n.add("fr", {
        weekStart: 1,

        january: "Janvier",
        february: "Février",
        march: "Mars",
        april: "Avril",
        may: "Mai",
        june: "Juin",
        july: "Juillet",
        august: "Août",
        september: "Septembre",
        october: "Octobre",
        november: "Novembre",
        december: "Décembre",

        january_short: "Jan",
        february_short: "Fév",
        march_short: "Mar",
        april_short: "Avr",
        may_short: "Mai",
        june_short: "Juin",
        july_short: "Juil",
        august_short: "Aoû",
        september_short: "Sep",
        october_short: "Oct",
        november_short: "Nov",
        december_short: "Déc",

        sunday: "Dimanche",
        monday: "Lundi",
        tuesday: "Mardi",
        wednesday: "Mercredi",
        thursday: "Jeudi",
        friday: "Vendredi",
        saturday: "Samedi",

        sunday_short: "Dim",
        monday_short: "Lun",
        tuesday_short: "Mar",
        wednesday_short: "Mer",
        thursday_short: "Jeu",
        friday_short: "Ven",
        saturday_short: "Sam",

        sunday_short_2: "D",
        monday_short_2: "L",
        tuesday_short_2: "M",
        wednesday_short_2: "M",
        thursday_short_2: "J",
        friday_short_2: "V",
        saturday_short_2: "S",

        label_ok: "OK",
        label_cancel: "Annuler",
        label_done: "Terminé",
        label_today: "Aujourd'hui",
        label_now: "Maintenant",
        label_clear: "Effacer",
        label_help: "Aide",
        label_yes: "Oui",
        label_no: "Non",
        label_random: "Aléatoire",
        label_save: "Enregistrer",
        label_reset: "Réinitialiser",
        label_submit: "Soumettre",
        label_add_user_color: "Ajouter aux couleurs",
        label_send: "Envoyer",
        label_accept: "Accepter",
        label_cookies_title: "Ce site utilise des cookies",
        label_cookies_text: "Ce site utilise des cookies pour vous garantir la meilleure expérience sur notre site.",
        label_choose_file: "Choisir le(s) fichier(s)",
        label_drop_file: "Cliquez ou déposez le(s) fichier(s) ici",
        label_files_selected: "{n} fichier(s) sélectionné(s)",

        label_days: "jours",
        label_hours: "heures",
        label_minutes: "min",
        label_seconds: "sec",
        label_month: "mois",
        label_months: "mois",
        label_day: "jour",
        label_year: "année",
        label_years: "années",

        label_rows_count: "Afficher :",
        label_search: "Rechercher :",
        label_table_info: "Affichage de $1 à $2 sur $3 entrées",
        label_prev: "Préc",
        label_next: "Suiv",
        label_all: "Tout",
        label_inspector: "Inspecteur",
        label_goto_page: "Aller à",
        label_enter_page: "Entrer la page...",
        label_empty: "Rien à afficher",
        label_user_colors: "Couleurs utilisateur",
        label_tiles: "Tuiles",
        label_list: "Liste",
        label_load_more: "Charger plus",
        label_buy: "Acheter",
        label_buy_now: "Acheter maintenant",
        label_buy_today: "Acheter aujourd'hui",
        label_download: "Télécharger",
        label_search_results: "Résultats de recherche",
        label_add: "Ajouter",
        label_edit: "Modifier",
        label_delete: "Supprimer",
        label_new: "Nouveau",
        label_sell: "Vendre",
        label_details: "Détails",
        label_sorting: "Tri",
        label_finish: "Terminer",
        label_play: "Lire",
        label_pause: "Pause",
        label_stop: "Arrêter",
        label_mute: "Muet",
        label_loop: "Boucle",

        label_on: "act",
        label_off: "dés",

        label_rename_tab: "Renommer l'onglet",
        label_close_tab: "Fermer l'onglet",
        label_close_other_tabs: "Fermer les autres onglets",
        label_close_tabs_left: "Fermer les onglets à gauche",
        label_close_tabs_right: "Fermer les onglets à droite",
        label_close_all_tabs: "Fermer tous les onglets",
        label_close_inactive_tabs: "Fermer les onglets inactifs",

        label_clear_input: "Effacer l'entrée",
        label_reveal_password: "Afficher le mot de passe",
        label_hide_password: "Masquer le mot de passe",
        label_generate_random: "Générer une valeur aléatoire",
        label_search_input: "Rechercher la valeur saisie",

        label_note: "Note",
        label_tip: "Astuce",
        label_info: "Info",
        label_warning: "Avertissement",
        label_question: "Question",
        label_error: "Erreur",
        label_success: "Succès",
        label_caution: "Prudence",
        label_alert: "Alerte",
        label_bug: "Bug",
        label_fuck: "Merde",
        label_important: "Important",
        label_shit: "Fichu",
        label_air: "Air",

        label_select_all: "Tout sélectionner",
        label_select_more: "Sélectionner...",
        label_select: "Sélectionner",
        label_filter: "Filtrer",

        label_collapse: "Réduire",
        label_attach: "Attacher",
    });
})();
